import { Avatar, Stack, Typography } from '@mui/material'
import { stackGap } from '../../../Constants&Theme/Spacing'
import React from 'react'

function StepHeader({ step, name }: { step: number; name: string }) {
  return (
    <Stack
      alignItems={'center'}
      direction={'row'}
      gap={stackGap.row}
      sx={{ mb: 1 }}
    >
      <Avatar sx={{ width: 24, height: 24 }}>{step}</Avatar>
      <Typography variant="h5">{name}</Typography>
    </Stack>
  )
}

export default StepHeader
